/**
 * 要素が縦または横にスクロール可能かどうかをチェックする関数
 * @param {HTMLElement} element - チェックする対象のHTML要素
 * @returns {boolean} - スクロール可能ならtrueを返す
 * @example
 * const element = document.getElementById('myElement');
 * console.log(isScrollable(element)); // スクロール可能かどうかを表示
 */
const isScrollable = (element) => {
    const isVerticalScrollable = element.scrollHeight > element.clientHeight;
    const isHorizontalScrollable = element.scrollWidth > element.clientWidth;
    return isVerticalScrollable || isHorizontalScrollable;
};

const doscrolls = document.querySelectorAll(".Doscroll")

doscrolls.forEach((doscroll) => {
    const target = document.querySelector(doscroll.dataset.target)

    if (isScrollable(target)) {
        doscroll.classList.add("is-shown")

        const close = () => {
            doscroll.classList.remove("is-shown")
        }

        target.addEventListener("click", close, { once: true })
        target.addEventListener("scroll", close, { once: true })
    }
})